export default __webpack_public_path__ + "static/media/gallery24.7ac05ae9.webp";